import { Component, Input, OnInit } from '@angular/core';

import { WsopNationalityRankingItem } from '../../core/interface/leaderboard.interface';

@Component({
  selector: 'app-wsop-nationality-ranking-table',
  templateUrl: './wsop-nationality-ranking-table.component.html',
  styleUrls: ['./wsop-nationality-ranking-table.component.scss']
})
export class WsopNationalityRankingTableComponent implements OnInit {
    @Input() progress: boolean;
    @Input() isMaintenance: boolean;
    @Input() isScrolling: boolean;
    @Input() set rankingList(list: WsopNationalityRankingItem[]) {
        if (!list || 0 === list.length) {
            return;
        }

        this.bottomList = list.splice(3);
        this.topList = list;
    }
    @Input() countryCode: string;
    @Input() countryCodes!: { [p: string]: string };

    public topList: WsopNationalityRankingItem[] = [];
    public bottomList: WsopNationalityRankingItem[] = [];

    public constructor() {
    }

    public async ngOnInit() {
    }
}
